import React from "react";

// Images
import businessImg from "../../images/platforms/fundgener-bg.png";
import sportImg from "../../images/platforms/sportgener-bg.png";
import cultureImg from "../../images/platforms/dancezonea-bg.png";

// Styles
import "./Events.scss";

const Events = () => {
  const eventCategories = [
    {
      title: "BUSINESS & NETWORKING",
      description: "Private gatherings · Partnerships · Global connections",
      image: businessImg,
      icon: "◎",
    },
    {
      title: "SPORT & PERFORMANCE",
      description: "Talent · Experiences · SportGeneR events",
      image: sportImg,
      icon: "◇",
    },
    {
      title: "CULTURE & ENTERTAINMENT",
      description: "Dance · Music · Social experiences · DanceZonea events",
      image: cultureImg,
      icon: "♪",
    },
  ];

  return (
    <section className="events-premium" id="events">
      <div className="events-inner">

        <div className="events-heading">
          <span className="events-eyebrow">VIEWGENER EXPERIENCES</span>

          <h1>EVENTS</h1>

          <h2>WHERE VISION BECOMES EXPERIENCE</h2>

          <p>
            Bringing people, ideas and opportunities together through
            experiences across the ViewGeneR ecosystem.
          </p>
        </div>

        <div className="events-grid">
          {eventCategories.map((event, index) => (
            <article className="event-premium-card" key={index}>
              <div
                className="event-image"
                style={{ backgroundImage: `url(${event.image})` }}
              >
                <div className="event-image-overlay"></div>
              </div>

              <div className="event-card-content">
                <span className="event-icon">{event.icon}</span>

                <h3>{event.title}</h3>

                <p>{event.description}</p>

                <span className="event-coming-soon">COMING SOON</span>
              </div>
            </article>
          ))}
        </div>

        <div className="events-signature">
          PEOPLE · IDEAS · OPPORTUNITIES · EXPERIENCES
        </div>

      </div>
    </section>
  );
};

export default Events;